export default class BrowserSupport {

	static vHFix(wrapElement) {
		let vh = window.innerHeight * 0.01;
		wrapElement.style.setProperty('--dpit-vh', `${vh}px`);
	}

	static isSupported = () => {
		const isSupported = !BrowserSupport.isIE();
		if (!isSupported) console.log('DP Intro Tours: Browser is not supported');
		return isSupported;
	}

	static isIE() {
		const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
		const msie = ua.indexOf('MSIE '); // IE 10 or older
		const trident = ua.indexOf('Trident/'); //IE 11
		return (msie > 0 || trident > 0);
	}

}